import {Pipe, Injectable, PipeTransform, Component} from '@angular/core';
import {MainComponent} from "../../main/main.component";

@Pipe({
  name: 'searchFilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {

  transform(items: any[], field: string, value: string, component: any): any[] {
    if (!value) {
      return items;
    }

    var searchTerm = value.trim().toLowerCase();

    var isUserFilter = this.isUserFilter(component);

    var filteredObjects = items.filter(item => {
      if (isUserFilter) {
        return (
          (item.name && item.name.toLowerCase().includes(searchTerm)) ||
          (item.email && item.email.toLowerCase().includes(searchTerm)) ||
          (item.organization_title && item.organization_title.toLowerCase().includes(searchTerm))
        );
      } else {
        return item[field] && item[field].toLowerCase().includes(searchTerm);
      }
    });

    if (isUserFilter) {
      component.usersCount = filteredObjects.length;
    }

    return filteredObjects;
  }

  isUserFilter(component: any): boolean {
    return component instanceof MainComponent;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/searchFilter.pipe.ts